import { render, staticRenderFns } from "./design_process.vue?vue&type=template&id=952938bc&scoped=true&"
import script from "./design_process.vue?vue&type=script&lang=js&"
export * from "./design_process.vue?vue&type=script&lang=js&"
import style0 from "./design_process.vue?vue&type=style&index=0&id=952938bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952938bc",
  null
  
)

export default component.exports